<mat-card class="card">
  <div class="table-container">
    <table
      class="container"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="sortChanged($event)"
      (contentChanged)="checkCheckBox()"
    >
      <ng-container
        *ngFor="let column of columns; trackBy: customTrackBy"
        matColumnDef="{{ column.field }}"
      >
        <ng-container [ngSwitch]="column.field">
          <ng-container *ngSwitchCase="'checkbox'">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                class="me-4 easy-checkbox"
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()"
                [disabled]="!dataSource.data.length"
                *ngIf="!column.hideCheckBoxInHeader"
              >
              </mat-checkbox>
            </th>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <ng-container *ngIf="column.label; else noColumnLabel">
              <th
                disabled="{{ !column.sortable }}"
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                sortActionDescription="Sort by {{ column.field }}"
                [formGroup]="formGroup"
                class="header-cell"
              >
                <div class="d-flex flex-column column-header">
                  <span
                    class="truncate-cell"
                    [matTooltip]="column.label | translate"
                    >{{ column.label | translate }}</span
                  >
                  <input
                    *ngIf="column.searchable"
                    class="search-input"
                    placeholder="{{ column.placeholder | translate }}"
                    matInput
                    type="text"
                    [formControlName]="column.field"
                    (input)="filterChanged()"
                    (keydown.space)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                  />
                  <select
                    *ngIf="column.filterable"
                    class="select"
                    [formControlName]="column.field"
                    (change)="filterChanged()"
                    style="width: 100%"
                  >
                    <option
                      *ngFor="let filterOption of column.filterOptions"
                      value="{{ filterOption.value }}"
                    >
                      {{ filterOption.label | translate }}
                    </option>
                    <ng-container
                      *ngIf="
                        column?.dependentOptions &&
                        formGroup.get(column.dependentOptions.dependency)
                          ?.value !== ''
                      "
                    >
                      <option
                        *ngFor="
                          let item of column.dependentOptions[
                            formGroup.get('mainType')?.value
                          ]
                        "
                        [value]="item.value"
                      >
                        {{ item.label | translate }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </th>
            </ng-container>
            <ng-template #noColumnLabel>
              <th mat-header-cell *matHeaderCellDef></th>
            </ng-template>
          </ng-container>
        </ng-container>
        <ng-container [ngSwitch]="column.field">
          <ng-container *ngSwitchCase="'checkbox'">
            <td mat-cell *matCellDef="let row" class="truncate-cell">
              <mat-checkbox
                class="me-4 easy-checkbox"
                (click)="$event.stopPropagation()"
                (change)="$event ? toggleRow(row[rowIdName]) : null"
                [checked]="selection.isSelected(row[rowIdName])"
                [aria-label]="checkboxLabel(row[rowIdName])"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'status'">
            <td mat-cell *matCellDef="let row" style="text-align: center">
              <mat-icon
                *ngIf="row.status === 'PUBLISHED'"
                class="published"
                [matTooltip]="'PRODUCTS.STATUS.OPTIONS.PUBLISHED' | translate"
                >done</mat-icon
              >
              <mat-icon
                *ngIf="row.status === 'DRAFT'"
                class="draft"
                fontSet="material-icons-outlined"
                [matTooltip]="'PRODUCTS.STATUS.OPTIONS.DRAFT' | translate"
                >pending</mat-icon
              >
              <mat-icon
                *ngIf="row.status === 'REJECTED'"
                class="rejected"
                [matTooltip]="'PRODUCTS.STATUS.OPTIONS.REJECTED' | translate"
                >close</mat-icon
              >
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'priced'">
            <td mat-cell *matCellDef="let row" class="truncate-cell">
              <a
                *ngIf="row.priced; else noPrice"
                [routerLink]="'/selling/prices/pricing/selected-products'"
                [queryParams]="{ s: row[rowIdName] }"
                >{{ "PRODUCTS.MODAL.PRICED" | translate }}</a
              >
              <ng-template #noPrice>-</ng-template>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'actions'">
            <td mat-cell *matCellDef="let row">
              <ng-container
                *ngTemplateOutlet="
                  actionsCell;
                  context: {
                    $implicit: row[rowIdName]
                  }
                "
              ></ng-container>
            </td>
          </ng-container>
          <ng-container *ngSwitchCase="'eanCodes'">
            <td mat-cell *matCellDef="let row">
              <p *ngFor="let ean of row.eanCodes" class="my-1">{{ ean }}</p>
            </td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td
              mat-cell
              *matCellDef="let row"
              class="truncate-cell"
              [style.text-align]="column.alignment ?? ''"
            >
              <a
                *ngIf="column.link"
                [routerLink]="customCellLink(row, column.field).routerLink"
                [queryParams]="customCellLink(row, column.field).queryParams"
                [matTooltip]="
                  customCellTooltip(row, column.field) ??
                  customCellValue(row, column.field)
                "
              >
                {{ customCellValue(row, column.field) }}
              </a>
              <span
                *ngIf="!column.link"
                [matTooltip]="
                  customCellTooltip(row, column.field) ??
                  customCellValue(row, column.field)
                "
              >
                {{ customCellValue(row, column.field) }}
              </span>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
  <div *ngIf="isLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <mat-paginator
    [length]="numberOfItems"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChanged($event)"
    showFirstLastButtons
    *ngIf="pageable"
  >
  </mat-paginator>
</mat-card>
